
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punetomahabaleshwar() {



  const cardData =
  {
    keyword: ' Pune to Mahabaleshwar Urbania on Rent',
    heading: 'Vaishnavi Travels: Pune to Mahabaleshwar Urbania on Rent',
    headingDescription: 'Vaishnavi Travels provides reliable and affordable Pune to Mahabaleshwar Urbania on Rent, perfect for family trips, corporate outings, school excursions, and weekend getaways. Our Force Urbania is well-maintained with spacious push-back seats, powerful air-conditioning, modern interiors, and ample luggage space, ensuring a smooth and comfortable journey through the scenic Pune–Mahabaleshwar route. With professional chauffeurs, timely pickups, and flexible booking options, we make group travel stress-free and enjoyable. Whether it’s a holiday retreat, religious yatra, or business tour, Vaishnavi Travels guarantees safe, comfortable, and dependable Urbania rental services from Pune to Mahabaleshwar.',

    top: 'Top Places to Visit in Mahabaleshwar with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Venna Lake",
    "description": "Venna Lake, built in 1842, is Mahabaleshwar’s most popular attraction, known for its boating, horse rides, and lakeside snacks. Surrounded by lush greenery, the lake is a favorite spot for families and couples. Visitors enjoy paddle and row boats while soaking in the cool mountain air. Evening strolls by the lake offer breathtaking views of the hills. Local vendors selling corn and strawberries add flavor to the experience. Venna Lake is Mahabaleshwar’s lively hub of leisure and charm."
  },
  {
    "title": "Arthur’s Seat",
    "description": "Arthur’s Seat, often called the ‘Queen of Points,’ is a spectacular viewpoint offering panoramic views of the deep Savitri gorge and the surrounding valleys. It is named after Sir Arthur Malet, who used to sit here mourning his wife and child. The spot is famous for its natural phenomenon where light objects thrown into the valley float back up due to air pressure. The breathtaking scenery attracts nature lovers and photographers alike. Arthur’s Seat is Mahabaleshwar’s iconic viewpoint of beauty and legend."
  },
  {
    "title": "Mapro Garden",
    "description": "Mapro Garden is a delightful attraction showcasing Mahabaleshwar’s famous strawberry and fruit products. Visitors enjoy fresh strawberry shakes, ice creams, and pizzas with a unique twist. The garden also houses a chocolate factory, nursery, and children’s play area. During the annual Strawberry Festival, the place comes alive with music and unlimited fruit tastings. Families love shopping for jams, syrups, and chocolates here. Mapro Garden is Mahabaleshwar’s sweet paradise for foodies and families."
  },
  {
    "title": "Pratapgad Fort",
    "description": "Pratapgad Fort, located 20 km from Mahabaleshwar, is a historic fort built by Chhatrapati Shivaji Maharaj in 1656. It is famous for the legendary battle where Shivaji defeated Afzal Khan. Visitors explore its massive gates, bastions, temples, and monuments dedicated to Maratha warriors. The fort offers breathtaking views of surrounding valleys and Konkan plains. Trekkers and history enthusiasts find it especially rewarding. Pratapgad is Mahabaleshwar’s proud symbol of Maratha valor and heritage."
  },
  {
    "title": "Elephant’s Head Point",
    "description": "Elephant’s Head Point is a unique rock formation that resembles the head and trunk of an elephant. Offering panoramic views of the Sahyadri ranges, it is one of Mahabaleshwar’s most photographed spots. The surrounding cliffs and valleys create a mesmerizing backdrop, especially during sunrise and sunset. Tourists enjoy the cool breezes and scenic beauty here. It is also a favorite stop for couples and nature lovers. Elephant’s Head Point is Mahabaleshwar’s natural wonder carved by time."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Lingmala Waterfall, located close to Mahabaleshwar, cascades from a height of 600 feet, creating a majestic spectacle. Surrounded by dense forests, it offers two viewpoints—one for a panoramic view and another near the smaller falls for close interaction. During monsoon, the waterfall is at its most powerful and scenic. Tourists enjoy trekking and photography in the misty surroundings. The spot is perfect for nature lovers and adventure seekers. Lingmala Waterfall is Mahabaleshwar’s monsoon paradise."
  },
  {
    "title": "Wilson Point",
    "description": "Wilson Point, the highest point in Mahabaleshwar at 1,439 meters, is famous for offering sunrise views. It has three watchtowers providing 360-degree panoramic views of the hills and valleys. Tourists gather early in the morning to watch the first rays of the sun light up the Sahyadris. The point is also ideal for stargazing at night due to its clear skies. Its open landscapes make it a peaceful retreat. Wilson Point is Mahabaleshwar’s vantage spot of dawn and beauty."
  },
  {
    "title": "Mahabaleshwar Temple",
    "description": "The Mahabaleshwar Temple, dedicated to Lord Shiva, is an ancient shrine built in the 16th century. It houses a swayambhu shivling believed to be 500 years old. The temple is architecturally simple yet spiritually powerful, attracting devotees throughout the year. Surrounded by hills, it exudes a tranquil atmosphere for meditation. Pilgrims often combine their visit with Panchganga Temple nearby. Mahabaleshwar Temple is the town’s spiritual and historical soul."
  },
  {
    "title": "Panchganga Temple",
    "description": "Panchganga Temple marks the origin of five rivers—Krishna, Venna, Savitri, Koyna, and Gayatri. Built by Raja Singhandeo of the Yadava dynasty, it is considered a highly sacred spot. The confluence of rivers is worshipped as a divine blessing. Pilgrims believe a dip here purifies the soul. The temple’s stone carvings and peaceful setting add to its charm. Panchganga Temple is Mahabaleshwar’s sacred site of natural and spiritual significance."
  },
  {
    "title": "Tapola (Mini Kashmir)",
    "description": "Tapola, located 25 km from Mahabaleshwar, is a serene village known as ‘Mini Kashmir’ for its picturesque backwaters of Shivsagar Lake. It is ideal for boating, kayaking, and camping. Surrounded by hills and forests, it offers a perfect escape for nature lovers and photographers. Trekkers use Tapola as a base for trails into the Sahyadris. Its untouched beauty makes it a hidden gem of the region. Tapola is Mahabaleshwar’s offbeat paradise of peace and adventure."
  }
],


     "services": [
    {
      "name": "Mahabaleshwar Urbania Travel Pune",
      "description": "Experience the scenic beauty of Mahabaleshwar in the comfort of a premium Force Urbania van from Pune. Our 13/17 seater Urbania vans offer ample space, ergonomic seating, and smooth suspension, ensuring a relaxed journey to the famous hill station. Perfect for weekend getaways, family trips, or corporate retreats, the vehicle comes equipped with powerful air conditioning, spacious interiors, large windows for panoramic views, and ample luggage space. Whether you're planning a group picnic, a couple’s scenic drive, or a corporate outing, this van provides a hassle-free, luxurious travel option. Our drivers are well-versed with the Pune-Mahabaleshwar route, ensuring safe, timely, and comfortable travel. Book online with flexible pick-up points, customizable itineraries, and competitive pricing, making your hill station trip unforgettable and stress-free."
    },
    {
      "name": "Force Urbania Pune to Mahabaleshwar",
      "description": "Travel from Pune to Mahabaleshwar in style with the robust and reliable Force Urbania van. Designed to handle the challenging hill terrain with ease, this vehicle is an excellent choice for group travelers seeking comfort and safety. It features high ground clearance, strong engine performance, and plush interiors tailored for long drives. Ideal for family vacations, corporate outings, or pilgrimage trips, the van accommodates up to 17 passengers with individual AC vents, cushioned seating, and noise insulation. With advanced GPS tracking, professional drivers, and 24/7 customer support, you can focus on enjoying the picturesque views and cool hill air while we take care of your travel logistics."
    },
    {
      "name": "Weekend Hill Station Urbania Rental",
      "description": "Make your weekend getaway to Mahabaleshwar seamless and memorable with our dedicated Urbania rental packages. Whether you are traveling with friends, family, or colleagues, our 13/17 seater Urbania vans provide the perfect blend of space, comfort, and convenience. Enjoy air-conditioned travel with ample legroom, multimedia entertainment options, and safe luggage compartments. We offer tailored trip plans that include early morning departures, scenic detours, and optional drop-offs at key tourist attractions like Venna Lake, Mapro Garden, and Pratapgad Fort. Our flexible rental plans include hourly, daily, and multi-day bookings, all backed by prompt roadside assistance and friendly drivers who prioritize your comfort and safety."
    },
    {
      "name": "13/17 Seater Urbania Mahabaleshwar Trip",
      "description": "Choose our spacious 13/17 seater Urbania vans for your Mahabaleshwar trip from Pune. The vehicle is designed to cater to mid-sized groups who desire a premium travel experience without compromising on cost-effectiveness. Equipped with ergonomic seats, USB charging ports, ambient lighting, and panoramic windows, this van transforms your road trip into an enjoyable journey. Whether it's a family outing, a college excursion, or a corporate bonding trip, our Urbania ensures smooth rides on winding roads, enhanced safety features, and excellent fuel efficiency. Booking includes driver services, route customization, and full insurance coverage, making your trip worry-free from start to finish."
    },
    {
      "name": "AC Urbania for Mahabaleshwar Outing",
      "description": "Stay cool and comfortable throughout your journey with our AC-equipped Urbania vans for Mahabaleshwar outings. Perfect for summer travel and long-distance drives, these vans feature powerful air conditioning systems that maintain a pleasant cabin temperature regardless of outside weather. Each seat is individually ventilated to keep all passengers refreshed. Additionally, the van includes noise reduction technology, soft cushioning, and smooth ride suspension to minimize fatigue during the hilly terrain trip. Ideal for families with kids, senior citizens, or corporate groups needing reliable, comfortable transportation for their Mahabaleshwar holiday or business retreat."
    },
    {
      "name": "Pune to Mahabaleshwar Family Van",
      "description": "Our Urbania vans are an excellent choice for family travel from Pune to Mahabaleshwar. With roomy interiors and easy accessibility, these vans accommodate your entire family comfortably along with your luggage. Child safety locks, seat belts, and clean interiors are standard to ensure a safe and hygienic environment for your loved ones. Entertainment systems help keep kids engaged during the trip, while ample storage space lets you bring along picnic baskets, camping gear, and more. Our courteous drivers are experienced in family travel, making scheduled stops and ensuring smooth navigation through the hills."
    },
    {
      "name": "Urbania for Couple Group Trip Pune",
      "description": "Planning a romantic or small group trip to Mahabaleshwar? Our 13/17 seater Urbania vans offer a cozy and intimate travel option with enhanced privacy features. Enjoy comfortable, cushioned seating, mood lighting, and uninterrupted views through large tinted windows. This vehicle is ideal for couples or small groups wanting to escape city life and soak in the hill station’s serenity. Our flexible booking options allow for half-day or full-day rentals, customized pick-up/drop-off locations, and scenic route suggestions that include popular spots like Lingmala Waterfalls and Arthur’s Seat."
    },
    {
      "name": "Urbania for Scenic Drive Pune",
      "description": "Explore the breathtaking landscapes between Pune and Mahabaleshwar in the smooth-riding Force Urbania van. Designed for scenic drives, the vehicle offers panoramic windows, optimal seating arrangements for group interaction, and advanced suspension to absorb road shocks. Whether you want to enjoy the lush greenery, valleys, or winding roads, this van makes the journey as delightful as the destination. Additional perks include onboard music systems, charging points, and refreshments storage, so your road trip is both enjoyable and convenient."
    },
    {
      "name": "Corporate Urbania to Mahabaleshwar",
      "description": "Impress your team and clients with our premium Urbania vans for corporate outings to Mahabaleshwar. These vans provide a professional and comfortable environment suitable for team building, offsite meetings, or client hospitality. Amenities include Wi-Fi connectivity, charging ports, plush seating, and privacy partitions for meetings on the go. Our corporate packages also offer branding opportunities and flexible pick-up/drop-off points. Drivers are trained for punctuality and discretion, ensuring a seamless experience for business travelers."
    },
    {
      "name": "Mahabaleshwar Picnic Van Hire Pune",
      "description": "Make your Mahabaleshwar picnic effortless with our specially tailored Urbania van hire service. Equipped with spacious seating and ample luggage space, it’s perfect for group picnics, outdoor activities, or day-long excursions. We provide optional add-ons such as picnic baskets, coolers, and portable seating arrangements. Our vans come with onboard entertainment and comfortable interiors to keep everyone relaxed during the trip. With multiple pick-up points and customizable routes, you can plan your perfect picnic without transportation worries."
    },
    {
      "name": "Urbania Tour Package Pune",
      "description": "Choose our all-inclusive Urbania tour packages from Pune to Mahabaleshwar, designed to simplify your travel planning. Packages include van rental, driver services, toll and parking charges, and suggested itinerary with sightseeing stops. We cater to families, corporate groups, and tourists looking for a hassle-free and enjoyable trip. Our packages can be customized for duration, destinations within Mahabaleshwar, and special requests like local guide services or meal stops. With 24/7 support and transparent pricing, you get a premium travel experience at great value."
    },
    {
      "name": "Road Trip Urbania Pune to Mahabaleshwar",
      "description": "Embark on an unforgettable road trip from Pune to Mahabaleshwar in our reliable and comfortable Urbania van. The vehicle is optimized for hill driving, featuring smooth handling, enhanced safety features, and spacious interiors to accommodate your group’s needs. Perfect for adventurous families, friends, or corporate groups, the trip can be tailored with planned stops at scenic viewpoints, local markets, and eateries. Our drivers are knowledgeable about the route and local attractions, offering insights and assistance to make your road trip memorable."
    },
    {
      "name": "Book Urbania Online for Hill Station",
      "description": "Conveniently book your Urbania van online for hill station trips from Pune to Mahabaleshwar. Our easy-to-use booking platform allows you to select vehicle type, seating capacity, trip duration, and optional extras with a few clicks. Enjoy transparent pricing, instant confirmations, and flexible cancellation policies. Whether planning a family holiday, corporate retreat, or group outing, online booking ensures your transport needs are met without hassle. Support is available round the clock for queries, route customization, and last-minute changes."
    }
  ],

"tableData": [
  ["Mahabaleshwar Urbania Travel Pune", "Force Urbania Pune to Mahabaleshwar"],
  ["Weekend Hill Station Urbania Rental", "13/17 Seater Urbania Mahabaleshwar Trip"],
  ["AC Urbania for Mahabaleshwar Outing", "Pune to Mahabaleshwar Family Van"],
  ["Urbania for Couple Group Trip Pune", "Urbania for Scenic Drive Pune"],
  ["Corporate Urbania to Mahabaleshwar", "Mahabaleshwar Picnic Van Hire Pune"],
  ["Urbania Tour Package Pune", "Road Trip Urbania Pune to Mahabaleshwar"],
  ["Book Urbania Online for Hill Station"]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Mahabaleshwar Urbania on Rent",
    "WhyChoosedescription": "Vaishnavi Travels offers comfortable and reliable Force Urbania rentals for the Pune to Mahabaleshwar route, perfect for family trips, group outings, and corporate tours."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Seating",
    "WhyChoosedescription": "Our Urbania vans come with plush seats, ample legroom, and air conditioning to ensure a relaxing journey from Pune to the scenic hill station of Mahabaleshwar."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Each vehicle is regularly serviced and thoroughly cleaned to provide a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Route Expertise",
    "WhyChoosedescription": "Our professional drivers are familiar with the Pune-Mahabaleshwar route, ensuring timely and safe travel through the Western Ghats."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, full-day, or multi-day rental options tailored to your sightseeing or corporate travel needs."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our pricing includes fuel, tolls, driver allowance, and taxes for a hassle-free and transparent rental experience."
  },
  {
    "WhyChooseheading": "Ideal for Family Trips, Corporate Outings, and Group Tours",
    "WhyChoosedescription": "Perfect for weekend getaways, corporate retreats, and group sightseeing in and around Mahabaleshwar."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our dedicated customer service team is available round-the-clock to assist with bookings, itinerary changes, and travel inquiries."
  }
]























  }




const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer 13 seater Force Urbania on rent for Pune to Mahabaleshwar trips?',
      answer: 'Yes, Vaishnavi Travels provides 13 seater Force Urbania vehicles for rent for trips from Pune to Mahabaleshwar, perfect for family outings, group tours, and corporate retreats.',
    },
    {
      question: 'What features does the 13 seater Force Urbania offer for Pune to Mahabaleshwar travel?',
      answer: 'The 13 seater Force Urbania offers spacious seating, air-conditioning, comfortable legroom, modern interiors, and sufficient luggage space to ensure a relaxing and enjoyable journey to Mahabaleshwar.',
    },
    {
      question: 'Are the vehicles and drivers reliable for Pune to Mahabaleshwar rentals?',
      answer: 'Absolutely! All vehicles are regularly serviced and well-maintained. Our professional drivers are experienced, courteous, and familiar with the Pune-Mahabaleshwar route to provide a safe and timely trip.',
    },
    {
      question: 'What is the rental cost for a Pune to Mahabaleshwar trip in a 13 seater Force Urbania?',
      answer: 'Rental costs typically start from ₹5,500 for Pune to Mahabaleshwar trips, depending on trip duration, distance, and any additional services requested.',
    },
    {
      question: 'Can I book the 13 seater Force Urbania for return trips between Pune and Mahabaleshwar?',
      answer: 'Yes, Vaishnavi Travels offers flexible booking options for one-way and return trips between Pune and Mahabaleshwar with transparent pricing.',
    },
    {
      question: 'How early should I book a 13 seater Urbania for Pune to Mahabaleshwar travel?',
      answer: 'It is recommended to book at least 3 days in advance, especially during peak tourist seasons and weekends, to ensure vehicle availability.',
    },
    {
      question: 'Is flexible pickup and drop-off available for Pune to Mahabaleshwar Force Urbania rentals?',
      answer: 'Yes, flexible pickup and drop locations are available in Pune, Mahabaleshwar, and nearby areas to best accommodate your travel plans.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Sameer Joshi",
    position: "Tourist",
    feedback:
      "We had a wonderful trip from Pune to Mahabaleshwar in the 13 seater Urbania rented from Vaishnavi Travels. The vehicle was comfortable and spacious, and the driver was very professional and friendly.",
    rating: 5,
  },
  {
    name: "Ms. Priya Nair",
    position: "Travel Enthusiast",
    feedback:
      "Vaishnavi Travels made our Mahabaleshwar trip memorable with their excellent service. The Urbania was well-maintained and perfect for our group. Highly recommended!",
    rating: 5,
    style: "style-2",
  }
];


































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mahabaleshwar Urbania on Rent",
  "image": "https://vaishnavitravel.com/assets/images/pune-to-mahabaleshwar-urbania-rental.jpg",
  "description": "Rent Force Urbania (13/17 seater) from Pune to Mahabaleshwar for a comfortable hill station trip. Ideal for family outings, corporate trips, and scenic drives with AC and experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.88",
    "ratingCount": "512"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5800",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/pune-to-mahabaleshwar-urbania-on-rent"
  }
};




  return (
    <div>

<Helmet>
  <title>Pune to Mahabaleshwar Urbania on Rent | 13 & 17 Seater AC Vans | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Rent Force Urbania (13/17 seater) from Pune to Mahabaleshwar for a comfortable hill station trip. Ideal for family outings, corporate trips, and scenic drives with AC and experienced drivers."
  />
  <meta
    name="keywords"
    content="Mahabaleshwar Urbania Travel Pune, Force Urbania Pune to Mahabaleshwar, Weekend Hill Station Urbania Rental, 13/17 Seater Urbania Mahabaleshwar Trip, AC Urbania for Mahabaleshwar Outing, Pune to Mahabaleshwar Family Van, Urbania for Couple Group Trip Pune, Urbania for Scenic Drive Pune, Corporate Urbania to Mahabaleshwar, Mahabaleshwar Picnic Van Hire Pune, Urbania Tour Package Pune, Road Trip Urbania Pune to Mahabaleshwar, Book Urbania Online for Hill Station"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/42.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomahabaleshwar;